export default __webpack_public_path__ + "static/media/bell-icon.405a6b1c.svg";